import * as React from "react";
import * as moment from "moment";
import { createValidator } from "not-valid";

import { BaseInput, SharedProps } from "../base-input";

export interface DateInputProps extends SharedProps<moment.Moment> {
    format?: string;
}

export class DateInput extends React.Component<DateInputProps> {

    public render() {
        const DateBaseInput = BaseInput as unknown as new () => BaseInput<moment.Moment | void>;

        const validator = createValidator<moment.Moment>(v => v !== undefined && v.isValid(), "Please enter a valid date");

        return (
            <DateBaseInput
                defaultValue={undefined}
                getValueFromInput={this.getValueFromInput}
                getValueForInput={this.getValueForInput}
                type="date"
                requiredValidator={validator}
                {...this.props}
            />
        );
    }

    private getValueFromInput = (value: string): moment.Moment | void => {
        const dateValue = moment.utc(value, this.getFormat());

        if (dateValue.isValid()) {
            return dateValue;
        }

        return undefined;
    }

    private getValueForInput = (value: moment.Moment): string => {
        if (!value || !value.isValid()) {
            return "";
        }

        return value.format(this.getFormat());
    }

    private getFormat = () => {
        return this.props.format || (moment as any).HTML5_FMT.DATE;
    }
}
